import React, { useState } from 'react';
import SimpleBanner from '../components/SimpleBanner';
import termsBg from '../assets/About.jpg'; // Reusing 'aboutBg' as a placeholder if 'termsBg' isn't available

const TermsOfUse = () => {
  // All dropdowns are closed by default
  const [openSections, setOpenSections] = useState({});

  const toggleSection = (sectionId) => {
    setOpenSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }));
  };

  const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600&family=Playfair+Display:wght@400&display=swap');

  body {
      background-color: #FFFFFF;
      margin: 0;
      padding: 0;
  }

  .terms-of-use-container {
      font-family: 'Open Sans', sans-serif;
      max-width: 800px;
      width: 100%;
      margin: 40px auto;
      padding: 0 20px;
      line-height: 1.6;
      color: #666666;
      box-sizing: border-box;
  }

  @media (min-width: 992px) {
      .terms-of-use-container {
          max-width: 85%;
          width: 85%;
      }
  }

  .effective-date-text {
      font-family: 'Open Sans', sans-serif;
      font-weight: 600;
      font-size: clamp(18px, 3vw, 24px);
      line-height: 100%;
      letter-spacing: 0%;
      text-align: center;
      text-transform: uppercase;
      color: #D6A54F;
      margin: 40px auto 20px auto;
      max-width: 800px;
      padding: 0 20px;
      display: block;
      box-sizing: border-box;
  }
  @media (min-width: 992px) {
      .effective-date-text {
          max-width: 85%;
          width: 85%;
      }
  }

  .intro-paragraph {
      font-family: 'Open Sans', sans-serif;
      font-weight: 300;
      font-size: clamp(16px, 2.5vw, 20px);
      line-height: 35px;
      letter-spacing: 0%;
      text-align: center;
      color: #666666;
      margin: 0 auto 30px auto;
      max-width: 800px;
      padding: 0 20px;
      box-sizing: border-box;
  }
  @media (min-width: 992px) {
      .intro-paragraph {
          max-width: 85%;
          width: 85%;
      }
  }

  .intro-paragraph a {
      font-family: 'Open Sans', sans-serif;
      font-weight: 300;
      font-size: inherit;
      line-height: inherit;
      letter-spacing: inherit;
      text-align: center;
      text-decoration: underline;
      text-decoration-style: solid;
      text-decoration-offset: 0%;
      text-decoration-thickness: 1px;
      text-decoration-skip-ink: auto;
      color: #007bff;
  }

  .section {
      margin-bottom: 15px;
      padding: 0;
      overflow: hidden;
  }

  .section-title {
      font-family: 'Playfair Display', serif;
      font-weight: 400;
      font-size: clamp(20px, 3vw, 20px);
      line-height: 60px;
      letter-spacing: 0%;
      color: #121212;
      margin: 0;
      padding: 0 0px 10px 0px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      border-bottom: 1px solid #ccc;
  }

  .arrow-icon {
      width: 1.2em;
      height: 1.2em;
      color: #888;
      transition: transform 0.3s ease-in-out;
      margin-left: 10px;
      flex-shrink: 0;
  }

  .arrow-icon.rotate {
      transform: rotate(180deg);
  }

  .section-content {
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.3s ease-out, padding 0.3s ease-out;
      padding: 0 0px;
      background-color: transparent;
  }

  .section-content.open {
      max-height: 1000px;
      padding: 15px 0px;
  }

  .section ul {
      list-style: none;
      padding: 0;
      margin: 0;
  }

  .section ul li {
      position: relative;
      padding-left: 1.5em;
      margin-bottom: 10px;
      font-family: 'Open Sans', sans-serif;
      font-weight: 400;
      font-size: clamp(14px, 2vw, 16px);
      line-height: clamp(20px, 3.5vw, 28px);
      letter-spacing: 0%;
      color: #666666;
  }

  .section ul li::before {
      content: "•";
      position: absolute;
      left: 0;
      top: 0;
      color: #000000;
      font-weight: bold;
      font-size: 1.2em;
      line-height: 1;
  }

  .section p {
      margin-bottom: 10px;
      font-family: 'Open Sans', sans-serif;
      font-weight: 400;
      font-size: clamp(14px, 2vw, 16px);
      line-height: clamp(20px, 3.5vw, 28px);
      letter-spacing: 0%;
      color: #666666;
  }

  .section p strong {
      font-weight: 600;
      font-size: inherit;
      line-height: inherit;
  }

  .contact-info {
      font-family: 'Open Sans', sans-serif;
      font-weight: 400;
      font-size: clamp(14px, 2vw, 16px);
      line-height: clamp(20px, 3.5vw, 28px);
      letter-spacing: 0%;
      color: #666666;
  }

  .contact-info a {
      font-family: 'Open Sans', sans-serif;
      font-weight: 400;
      font-size: inherit;
      line-height: inherit;
      letter-spacing: inherit;
      text-decoration: none;
      color: inherit;
      cursor: pointer;
  }
`;

  return (
    <>
      <style>{styles}</style>

      {/* SimpleBanner component */}
      <SimpleBanner bgImage={termsBg} headingText="Terms of Use" />

      {/* Effective Date and Intro Paragraph */}
      <p className="effective-date-text">EFFECTIVE DATE: JUNE 13, 2025</p>

      <p className="intro-paragraph">
        Welcome to <a href="https://admin.theporch.in" target="_blank" rel="noopener noreferrer">https://admin.theporch.in</a>. By accessing this site, you agree to the following terms and conditions.
      </p>

      {/* Main Terms of Use Container with Dropdowns */}
      <div className="terms-of-use-container">
        {/* Acceptance Section */}
        <section className="section">
          <h3
            className={`section-title ${openSections['acceptance'] ? 'open' : ''}`}
            onClick={() => toggleSection('acceptance')}
          >
            Acceptance
            <svg
              className={`arrow-icon ${openSections['acceptance'] ? 'rotate' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </h3>
          <div className={`section-content ${openSections['acceptance'] ? 'open' : ''}`}>
            <p>
              Using this site implies acceptance of these terms. If you disagree, please refrain from using the site.
            </p>
          </div>
        </section>

        {/* Use of Content Section */}
        <section className="section">
          <h3
            className={`section-title ${openSections['useOfContent'] ? 'open' : ''}`}
            onClick={() => toggleSection('useOfContent')}
          >
            Use of Content
            <svg
              className={`arrow-icon ${openSections['useOfContent'] ? 'rotate' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </h3>
          <div className={`section-content ${openSections['useOfContent'] ? 'open' : ''}`}>
            <p>
              All text, images, and logos are the property of The Porch Cafe & Restaurant. You may view or share content for personal, non-commercial use only.
            </p>
          </div>
        </section>

        {/* Reservations & Orders Section */}
        <section className="section">
          <h3
            className={`section-title ${openSections['reservationsOrders'] ? 'open' : ''}`}
            onClick={() => toggleSection('reservationsOrders')}
          >
            Reservations & Orders
            <svg
              className={`arrow-icon ${openSections['reservationsOrders'] ? 'rotate' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </h3>
          <div className={`section-content ${openSections['reservationsOrders'] ? 'open' : ''}`}>
            <ul>
              <li>Online bookings are subject to availability and confirmation.</li>
              <li>The Porch reserves the right to modify, cancel, or refuse any reservation or order under special circumstances.</li>
            </ul>
          </div>
        </section>

        {/* User Conduct Section */}
        <section className="section">
          <h3
            className={`section-title ${openSections['userConduct'] ? 'open' : ''}`}
            onClick={() => toggleSection('userConduct')}
          >
            User Conduct
            <svg
              className={`arrow-icon ${openSections['userConduct'] ? 'rotate' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </h3>
          <div className={`section-content ${openSections['userConduct'] ? 'open' : ''}`}>
            <p>You agree not to:</p>
            <ul>
              <li>Misuse the site for fraudulent or illegal activity.</li>
              <li>Upload any harmful, offensive, or unauthorized content.</li>
            </ul>
          </div>
        </section>

        {/* Third-Party Links Section */}
        <section className="section">
          <h3
            className={`section-title ${openSections['thirdPartyLinks'] ? 'open' : ''}`}
            onClick={() => toggleSection('thirdPartyLinks')}
          >
            Third-Party Links
            <svg
              className={`arrow-icon ${openSections['thirdPartyLinks'] ? 'rotate' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </h3>
          <div className={`section-content ${openSections['thirdPartyLinks'] ? 'open' : ''}`}>
            <p>
              Our website may link to delivery or review partners (e.g., Zomato, Google Reviews). We are not responsible for third-party content or practices.
            </p>
          </div>
        </section>

        {/* Limitation of Liability Section */}
        <section className="section">
          <h3
            className={`section-title ${openSections['limitationOfLiability'] ? 'open' : ''}`}
            onClick={() => toggleSection('limitationOfLiability')}
          >
            Limitation of Liability
            <svg
              className={`arrow-icon ${openSections['limitationOfLiability'] ? 'rotate' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </h3>
          <div className={`section-content ${openSections['limitationOfLiability'] ? 'open' : ''}`}>
            <p>
              We are not liable for inaccuracies, downtime, or losses arising from site use. All use is at your own risk.
            </p>
          </div>
        </section>

        {/* Changes to Terms Section */}
        <section className="section">
          <h3
            className={`section-title ${openSections['changesToTerms'] ? 'open' : ''}`}
            onClick={() => toggleSection('changesToTerms')}
          >
            Changes to Terms
            <svg
              className={`arrow-icon ${openSections['changesToTerms'] ? 'rotate' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </h3>
          <div className={`section-content ${openSections['changesToTerms'] ? 'open' : ''}`}>
            <p>
              We may revise these terms at any time. Your continued use of the site signifies acceptance of the updated terms.
            </p>
          </div>
        </section>

        {/* Governing Law Section */}
        <section className="section">
          <h3
            className={`section-title ${openSections['governingLaw'] ? 'open' : ''}`}
            onClick={() => toggleSection('governingLaw')}
          >
            Governing Law
            <svg
              className={`arrow-icon ${openSections['governingLaw'] ? 'rotate' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </h3>
          <div className={`section-content ${openSections['governingLaw'] ? 'open' : ''}`}>
            <p>
              These terms are governed by the laws of India. Jurisdiction lies with the courts of Kota, Rajasthan.
            </p>
          </div>
        </section>

        {/* Contact Us Section */}
        <section className="section">
          <h3
            className={`section-title ${openSections['contactUs'] ? 'open' : ''}`}
            onClick={() => toggleSection('contactUs')}
          >
            Contact Us
            <svg
              className={`arrow-icon ${openSections['contactUs'] ? 'rotate' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </h3>
          <div className={`section-content ${openSections['contactUs'] ? 'open' : ''}`}>
            <p className="contact-info">
              Rooftop Area, Hotel The Pride, 267, Rajeev Gandhi Nagar, Kota - 324005<br />
              <a href="mailto:info@theporchcafe.in">info@theporchcafe.in</a><br />
              <a href="tel:+919024283004">+91 902 428 3004</a> | <a href="tel:+919602679997">+91 960 267 9997</a>
            </p>
          </div>
        </section>
      </div>
    </>
  );
};

export default TermsOfUse;